import React from 'react';
import { LeftMenuItem } from '../shared/LeftMenuItem';
import { NotificationFlagsCategories } from '../../../../models/NotificationFlags/NotificationFlagsCategories';

export const DataRequestMenuItem = () => (
    <LeftMenuItem
        icon="pe-7s-share"
        label="Data Request"
        to="/data-request-dashboard/others"
        flagCode={NotificationFlagsCategories.OtherDataRequests}
        trackingAction="Data Request"
        gtmCategory="Data Request"
    />
);
